// extracted by mini-css-extract-plugin
export var errorsContainer = "_sf-1";
export var link = "_sf-0";